import { render, staticRenderFns } from "./DossierAutoSaleRowSettingEdit.vue?vue&type=template&id=b048c252&scoped=true&"
import script from "./DossierAutoSaleRowSettingEdit.vue?vue&type=script&lang=ts&"
export * from "./DossierAutoSaleRowSettingEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b048c252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b048c252')) {
      api.createRecord('b048c252', component.options)
    } else {
      api.reload('b048c252', component.options)
    }
    module.hot.accept("./DossierAutoSaleRowSettingEdit.vue?vue&type=template&id=b048c252&scoped=true&", function () {
      api.rerender('b048c252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DossierAutoSaleRowSettingEdit.vue"
export default component.exports